import { Injectable, Signal, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationStateService {
  private readonly hasSecondaryAsideContentState = signal(false);

  readonly hasSecondaryAsideContent: Signal<boolean> =
    this.hasSecondaryAsideContentState.asReadonly();

  setHasSecondaryAsideContent(value: boolean): void {
    this.hasSecondaryAsideContentState.set(value);
  }
}
